import React, { Component, push } from "react";
import { withRouter } from "react-router-dom";
import { SingleSelect } from "react-select-material-ui";
import Moment from "react-moment";
import moment from "moment-timezone";
import { findIana } from "windows-iana";
import {
  Grommet,
  Box,
  Header,
  Button,
  Menu,
  Main,
  Heading,
  Paragraph,
  Footer,
  Text,
  Anchor,
  DropButton,
  Stack,
  Avatar,
  TextInput,
  Grid,
  Card,
  Form,
  FormField,
  CheckBoxGroup,
  Select,
  CardHeader,
  CardBody,
  List,
  Image,
  CheckBox,
  DateInput,
  Tabs,
  Tab,
  Layer,
  Tip,
  Spinner,
  ResponsiveContext,
} from "grommet";
import {
  Hpe,
  More,
  Help,
  Channel,
  Console,
  Notification,
  Search,
  New,
  Like,
  Directions,
  Favorite,
  FormPrevious,
  Filter,
  Dislike,
  Chat,
  Share,
  Download,
  ScheduleNew,
  Launch,
  AddCircle,
  Edit,
  Trash,
  Validate,
  Clear,
  Play,
  Multimedia,
  DocumentPdf,
  Inspect,
  Close,
  Calendar,
} from "grommet-icons";
import { hpe as theme } from "grommet-theme-hpe";
import auth from "./Security/Auth";
import {
  callApiGetJson,
  callApiPostJson,
  OnDemandRefreshInterval,
  callApiGetJsonwithEP,
} from "./GlobalSettings";
import Launchdemospinner from "./Launchdemospinner";
import InfoWarning from "./InfoWarning";

class AvailableTimeSlots extends Component {
  constructor(props) {
    super(props);

    this.state = {
      AvailableTimes: this.props.Availabilities,
      ForDemo: this.props.demo,
      TabIndex: 1,
      //slidderVal = this.props.slidder
    };

    this.checkPastTime = this.checkPastTime.bind(this);
    this.formatTime = this.formatTime.bind(this);
    this.OnActivate = this.OnActivate.bind(this);
  }

  componentDidMount() {
    console.log("Fetched Slots Supplied are ", this.state.AvailableTimes);
  }

  OnActivate(index) {
    this.setState({ TabIndex: index });
  }

  checkPastTime(time) {
    var date = new Date();
    var hours = date.getHours();
    //var hours_round = hours % 12;
    //hours_round = hours_round ? hours_round : 12;
    //var minutes =date.getMinutes();
    //var AmPm = hours >= 12 ? "pm" : "am";

    // console.log('UserInfo:', this.state.UserInfo);
    //This ensures user cannot select a time that is prior to the 'Lead Time' restriction.  Disables times that are prior to Lead Time, but ONLY for non-Event Approvers.
    if (
      this.props.demo &&
      this.props.demo.Content_LeadTime &&
      this.props.demo.Content_LeadTime > 0
    )
      date.setTime(
        date.getTime() + this.props.demo.Content_LeadTime * 86400000
      );

    if (time.getTime() > date.getTime()) {
      return false;
    } else {
      return true;
    }
  }

  formatTime(date) {
    var hours = date.getHours();
    var minutes = date.getMinutes();
    var ampm = hours >= 12 ? "pm" : "am";
    hours = hours % 12;
    hours = hours ? hours : 12; // the hour '0' should be '12'
    minutes = minutes < 10 ? "0" + minutes : minutes;
    //var strTime = hours + ':' + minutes + ' ' + ampm;

    return hours + ":" + minutes + " " + ampm;
  }

  render() {
    /*     var timeZones = moment.tz.names();

    for (var timezone of timeZones) {
      console.log(moment.tz(timezone));
    } */

    var IANATZ = null;
    console.log("Windows TimeZone Selected is - ", this.props.tzIANA);
    if (this.props.tzIANA !== undefined) {
      var convertedTZ = findIana(this.props.tzIANA);
      console.log("IANA Converted TimeZone Selected is - ", convertedTZ);
      if (convertedTZ && convertedTZ.length > 0) {
        IANATZ = convertedTZ[0];
      }
    }
    console.log("Picked IANA TZ for selected TZ is - ", IANATZ);

    var tzDisp = IANATZ ? this.props.tzIANA : "Local Timezone";

    var month = new Array();
    month[0] = "Jan";
    month[1] = "Feb";
    month[2] = "Mar";
    month[3] = "Apr";
    month[4] = "May";
    month[5] = "Jun";
    month[6] = "Jul";
    month[7] = "Aug";
    month[8] = "Sep";
    month[9] = "Oct";
    month[10] = "Nov";
    month[11] = "Dec";

    var weekdays = new Array();
    weekdays[0] = "Sunday";
    weekdays[1] = "Monday";
    weekdays[2] = "Tuesday";
    weekdays[3] = "Wednesday";
    weekdays[4] = "Thursday";
    weekdays[5] = "Friday";
    weekdays[6] = "Saturday";

    const size = "small";
    var demo_data = this.state.ForDemo;
    var AllSlots = this.state.AvailableTimes;
    var slide = this.state.slidderVal;

    var RequestDay_ActualSlots = undefined;
    var PrevDay_ActualSlots = undefined;
    var NextDay_ActualSlots = undefined;

    console.log(
      "Requested Day Slots are ",
      AllSlots.RequestedDay.AvailableStartTimes
    );
    if (
      AllSlots.RequestedDay.AvailableStartTimes
      // AllSlots.RequestedDay.AvailableStartTimes.Length > 0
    ) {
      RequestDay_ActualSlots = new Array();

      AllSlots.RequestedDay.AvailableStartTimes.map((availDate) => {
        var myDate = new Date(availDate);
        var pastTime = this.checkPastTime(myDate);
        if (!pastTime) {
          RequestDay_ActualSlots.push(availDate);
        }
      });
    }

    if (
      AllSlots.PreviousDay.AvailableStartTimes
      // AllSlots.RequestedDay.AvailableStartTimes.Length > 0
    ) {
      PrevDay_ActualSlots = new Array();

      AllSlots.PreviousDay.AvailableStartTimes.map((availDate) => {
        var myDate = new Date(availDate);
        var pastTime = this.checkPastTime(myDate);
        if (!pastTime) {
          PrevDay_ActualSlots.push(availDate);
        }
      });
    }

    if (
      AllSlots.NextDay.AvailableStartTimes
      // AllSlots.RequestedDay.AvailableStartTimes.Length > 0
    ) {
      NextDay_ActualSlots = new Array();

      AllSlots.NextDay.AvailableStartTimes.map((availDate) => {
        var myDate = new Date(availDate);
        var pastTime = this.checkPastTime(myDate);
        if (!pastTime) {
          NextDay_ActualSlots.push(availDate);
        }
      });
    }

    console.log("Previous Day Slots are ", RequestDay_ActualSlots);
    console.log("Requested Day  Slots are ", PrevDay_ActualSlots);
    console.log("Next Day  Slots are ", NextDay_ActualSlots);

    return (
      <Layer animated modal position="center" onEsc={this.props.hide}>
        <Box align="center" justify="start" direction="column">
          <Box
            align="center"
            justify="center"
            border={{ style: "solid" }}
            gap="small"
          >
            <Box
              align="center"
              justify="center"
              background={{ color: "brand" }}
              fill="horizontal"
            >
              <Box
                align="center"
                justify="between"
                direction="row"
                gap="medium"
                fill="horizontal"
              >
                <Heading size="small" level="1" margin="small">
                  Schedule a demonstration
                </Heading>
                <Button icon={<Close />} secondary onClick={this.props.hide} />
              </Box>
              <Text size="xlarge">{demo_data.Content_Title}</Text>
            </Box>
            <Box
              align="center"
              justify="center"
              fill
              pad={{ horizontal: "small" }}
              gap="xsmall"
              flex
            >
              <Box
                align="center"
                justify="center"
                fill
                pad={{ vertical: "xsmall", top: "xsmall" }}
                direction="column"
                basis="1/3"
                margin="small"
              >
                <Tabs
                  activeIndex={this.state.TabIndex}
                  onActive={(index) => {
                    this.OnActivate(index);
                  }}
                  justify="start"
                  flex="shrink"
                  //Activeindex={2}
                >
                  <Tab
                    title={
                      weekdays[new Date(AllSlots.PreviousDay.Day).getDay()] +
                      " " +
                      month[new Date(AllSlots.PreviousDay.Day).getMonth()] +
                      "-" +
                      new Date(AllSlots.PreviousDay.Day).getDate()
                    }
                    plain={false}
                    icon={<Calendar />}
                    reverse={false}
                  >
                    <Box
                      align="stretch"
                      justify="start"
                      gap="xsmall"
                      direction="column"
                      basis="medium"
                    >
                      <Text margin="small">
                        Day before Requested Day's Available start times:
                      </Text>
                      <Box
                        align="stretch"
                        justify="start"
                        direction="row"
                        flex
                        basis="medium"
                        margin="xsmall"
                        gap="large"
                        overflow="auto"
                      >
                        <Grid
                          rows="xxsmall"
                          columns={[
                            { size: "xsmall", count: "fill" },
                            "xsmall",
                            "xsmall",
                            "xsmall",
                            "xsmall",
                            "xsmall",
                          ]}
                          width="xsmall"
                          fill="horizontal"
                          gap="medium"
                        >
                          {/* <List data={RequestDay_ActualSlots}>
                              {(datumR, index) => ( */}
                          {PrevDay_ActualSlots.map((datumP, index) => (
                            <Card
                              background={{ color: "control" }}
                              pad="small"
                              justify="center"
                              direction="column"
                              align="center"
                              gap="xsmall"
                              onClick={(selectedStartDate) =>
                                this.props.HandleSelectedTime(new Date(datumP))
                              }
                            >
                              {IANATZ
                                ? moment(datumP).tz(IANATZ).format("LT")
                                : this.formatTime(new Date(datumP))}
                            </Card>
                          ))}
                        </Grid>
                      </Box>
                    </Box>
                  </Tab>
                  <Tab
                    title={
                      weekdays[new Date(AllSlots.RequestedDay.Day).getDay()] +
                      " " +
                      month[new Date(AllSlots.RequestedDay.Day).getMonth()] +
                      "-" +
                      new Date(AllSlots.RequestedDay.Day).getDate()
                    }
                    plain={false}
                    icon={<Calendar />}
                    reverse={false}
                  >
                    <Box
                      align="stretch"
                      justify="start"
                      gap="xsmall"
                      direction="column"
                      basis="medium"
                    >
                      <Text margin="small">
                        Requested Day's Available start times:
                      </Text>
                      <Box
                        align="stretch"
                        justify="start"
                        direction="row"
                        flex
                        basis="medium"
                        margin="xsmall"
                        gap="large"
                        overflow="auto"
                      >
                        <Grid
                          rows="xxsmall"
                          columns={[
                            { size: "xsmall", count: "fill" },
                            "xsmall",
                            "xsmall",
                            "xsmall",
                            "xsmall",
                            "xsmall",
                          ]}
                          width="xsmall"
                          fill="horizontal"
                          gap="medium"
                        >
                          {/* <List data={RequestDay_ActualSlots}>
                              {(datumR, index) => ( */}
                          {RequestDay_ActualSlots.map((datumR, index) => (
                            <Card
                              background={{ color: "control" }}
                              pad="small"
                              justify="center"
                              direction="column"
                              align="center"
                              gap="xsmall"
                              onClick={(selectedStartDate) =>
                                this.props.HandleSelectedTime(new Date(datumR))
                              }
                            >
                              {IANATZ
                                ? moment(datumR).tz(IANATZ).format("LT")
                                : this.formatTime(new Date(datumR))}
                            </Card>
                          ))}
                        </Grid>
                      </Box>
                    </Box>
                  </Tab>
                  <Tab
                    title={
                      weekdays[new Date(AllSlots.NextDay.Day).getDay()] +
                      " " +
                      month[new Date(AllSlots.NextDay.Day).getMonth()] +
                      "-" +
                      new Date(AllSlots.NextDay.Day).getDate()
                    }
                    plain={false}
                    icon={<Calendar />}
                    reverse={false}
                  >
                    <Box
                      align="stretch"
                      justify="start"
                      gap="xsmall"
                      direction="column"
                      basis="medium"
                    >
                      <Text margin="small">
                        Next Day of Requested Day's Available start times:
                      </Text>
                      <Box
                        align="stretch"
                        justify="start"
                        direction="row"
                        flex
                        basis="medium"
                        margin="xsmall"
                        gap="large"
                        overflow="auto"
                      >
                        <Grid
                          rows="xxsmall"
                          columns={[
                            { size: "xsmall", count: "fill" },
                            "xsmall",
                            "xsmall",
                            "xsmall",
                            "xsmall",
                            "xsmall",
                          ]}
                          width="xsmall"
                          fill="horizontal"
                          gap="medium"
                        >
                          {/* <List data={RequestDay_ActualSlots}>
                              {(datumR, index) => ( */}
                          {NextDay_ActualSlots.map((datumN, index) => (
                            <Card
                              background={{ color: "control" }}
                              pad="small"
                              justify="center"
                              direction="column"
                              align="center"
                              gap="xsmall"
                              onClick={(selectedStartDate) =>
                                this.props.HandleSelectedTime(new Date(datumN))
                              }
                            >
                              {IANATZ
                                ? moment(datumN).tz(IANATZ).format("LT")
                                : this.formatTime(new Date(datumN))}
                            </Card>
                          ))}
                        </Grid>
                      </Box>
                    </Box>
                  </Tab>
                </Tabs>
              </Box>
              <Box
                align="stretch"
                justify="start"
                fill="horizontal"
                gap="xsmall"
                direction="row"
                basis="xxsmall"
              >
                <Text>
                  *All times are shown in{" "}
                  <b>
                    <em>
                      <mark>{tzDisp}</mark>
                    </em>
                  </b>
                </Text>
              </Box>
            </Box>
          </Box>
        </Box>
      </Layer>
    );
  }
}

export default AvailableTimeSlots;
